export function checkIsInvalidScore(
  score: number | null | undefined,
  testingActive: boolean
) {
  return (
    // @ts-ignore - score can be compared to number as we've checked it's not null or undefined
    testingActive && (isNaN(score) || score === null || score < 0 || score > 1)
  );
}
